import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        const step = this.$('step')[0];
        const title = this.$('title')[0];

        setTimeout(() => {
            if (step) step.classList.add('is-active');
            if (title) title.classList.add('is-active');
        }, 600);
    }
}
